module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/close-8d3cc6427cf12fdf68dc4f5793f9dfc9.png";